import { Switch } from '@components/ui/switch';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { cn } from '@utils/cn';
import { useTranslation } from 'react-i18next';
import { FullDaySwitchProps } from './types';

export const FullDaySwitch = ({
  checked,
  onCheckedChange,
  hasOutOfScopeRecords,
  label = '24h',
}: FullDaySwitchProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'fullDaySwitch' });
  const showHint = !checked && hasOutOfScopeRecords;

  const toggle = (
    <Switch
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="w-9 data-[state=unchecked]:bg-neutral-100"
      thumbClassName={cn(
        'data-[state=checked]:translate-x-5',
        !checked && hasOutOfScopeRecords && 'bg-danger-400',
      )}
    />
  );

  return (
    <div className="flex items-center gap-2">
      {showHint ? (
        <AppTooltip context={t('outOfScopeHint')}>
          <span className="inline-flex">{toggle}</span>
        </AppTooltip>
      ) : (
        toggle
      )}
      <span className="text-m text-neutral-400">{label}</span>
    </div>
  );
};
